import App from 'App';
import 'index.css';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './i18n';

const container = document.getElementById('root') as HTMLElement;

// Always use createRoot - pre-rendered HTML is for SEO bots only
createRoot(container).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
